import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ModalHolderComponent } from "@modules/+new/shared/universal-modal/components/holder/modal-holder.component";
import { BasicHeaderComponent } from "@modules/+new/shared/universal-modal/components/_headers/basic/basic-header.component";
import { RouterModule } from "@angular/router";
import { RenderModalComponent } from "@modules/+new/shared/universal-modal/components/render/render-modal.component";
import { ModalDemoEntryModule } from "@modules/+new/shared/universal-modal/_demo/modal-demo-entry.module";
import { TranslationPipeModule } from "@modules/core/pipes/translation-pipe/translation-pipe.module";
import { DefaultHeaderComponent } from "./components/_headers/default/default-header.component";
import { ConfirmComponent } from "./components/_presets/confirm/confirm.component";
import { SuccessComponent } from "./components/_presets/success/success.component";
import { FailComponent } from "@modules/+new/shared/universal-modal/components/_presets/fail/fail.component";
import { A11yModule } from "@angular/cdk/a11y";
import { PendingPresetComponent } from "./components/_presets/pending-preset/pending-preset.component";
import { TakingLongerPendingPresetComponent } from "./components/_presets/taking-longer-pending-preset/taking-longer-pending-preset.component";
import { CoreModule } from "@modules/core/core.module";
import { EmailMismatchPresetComponent } from "./components/_presets/email-mismatch-preset/email-mismatch-preset.component";
import { OrderHeaderComponent } from "@modules/+new/shared/universal-modal/components/_headers/order-variation/order-header.component";

@NgModule({
	declarations: [
		ModalHolderComponent,
		RenderModalComponent,
		BasicHeaderComponent,
		DefaultHeaderComponent,
		OrderHeaderComponent,
		ConfirmComponent,
		SuccessComponent,
		FailComponent,
		PendingPresetComponent,
		TakingLongerPendingPresetComponent,
		EmailMismatchPresetComponent
	],
	imports: [CommonModule, RouterModule, ModalDemoEntryModule, TranslationPipeModule, A11yModule, CoreModule],
	exports: [
		ModalHolderComponent,
		RenderModalComponent,
		BasicHeaderComponent,
		DefaultHeaderComponent,
		OrderHeaderComponent,
		ConfirmComponent,
		SuccessComponent,
		FailComponent
	]
})
export class UniversalModalModule {}
